import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import NotFoundImage from '../../assets/images/404/404-graphic.png';
import NotFoundIcon from '../../assets/images/404/404-icon.png';
import SeoHeadMeta from './SeoHeadMeta';
import { seoTitles } from '../../utils/commonVariables';

function NotFoundContainer({sendMeta}) {
    useEffect(() => {
        document.querySelector('body').classList.add('white-bg');
        return function cleanup() {
            document.querySelector('body').classList.remove('white-bg');
        }
    }, []);
    return (<div className="not-found__container">
        {
            sendMeta && <SeoHeadMeta title={seoTitles.loggedOut.notFound}>
                <tite>{seoTitles.loggedOut.notFound}</tite>
            </SeoHeadMeta>
        }
        <div className="not-found__left">
            <img src={NotFoundImage} alt="not found" />
        </div>
        <div className="not-found__right">
            <p className="not-found__title">Oh Crêpe!</p>
            <img src={NotFoundIcon} alt="not found" />
            <p className="not-found__subtitle">Don’t Go Bananas</p>
            <Link to={`/`}>
                Go to Homepage
            </Link>
        </div>
    </div>)
};

export default NotFoundContainer;